import(/* webpackMode: "eager" */ "/root/repo/src/app/(services)/resume-writing/resume-status/page.tsx");
